module.exports = __webpack_public_path__ + "img/two.c1d84329.png";